import React from 'react';
import { useSelector } from 'react-redux';
import { currentUserFirstLastNameSelector } from 'redux/selectors';
import useProfileData from './hooks/useProfileData';
import { truthyDadValues } from './common';

/**
 * This displays the current development environment (dev, uat, prod) and
 * the name of the user if running as someone else.
 */
const EnvironmentInfoBar = () => {
  const isLoading = useProfileData();
  const isRunningAs = useSelector((state: any) =>
    truthyDadValues.includes(
      state?.Profile?.BIOGRAPHICAL?.IS_RUNNING_AS ?? false
    )
  );
  const { sName = '' } = useSelector(currentUserFirstLastNameSelector) as {
    sName: string;
  };

  const environment = process.env.REACT_APP_STAGE;
  const showEnvironmentInfoBar =
    !isLoading && (environment !== 'prod' || isRunningAs);

  return showEnvironmentInfoBar ? (
    <div className='environmentInfoBar'>
      {environment !== 'prod' && (
        <p className='t-paragraph--small'>
          <strong>Test environment</strong> - {environment}
        </p>
      )}
      {isRunningAs && (
        <p className='t-paragraph--small'>
          Running as <strong>{sName}</strong>
        </p>
      )}
    </div>
  ) : null;
};

export default EnvironmentInfoBar;
